import { SearchScenarioId } from 'owa-search-next-common';
import { action } from 'satcheljs';

const clearSearchBox = action('clearSearchBox', (scenarioId: SearchScenarioId) => ({
    scenarioId,
}));

export default clearSearchBox;
